import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QRCode from "react-qr-code";
import { Button } from "components/button";
import AuthContext from "contexts/AuthContext";
import { useTranslation } from "react-i18next";
import { getQueryParams } from "lib/utils";

export default function InStoreConfirmation() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = getQueryParams(location.search);
  const { logoutHandler } = useContext(AuthContext);

  // Get the takebackId from query params
  const takebackId = queryParams.takebackId;

  const handleSignOut = () => {
    logoutHandler();
    navigate(t("urls.signup_store_start"));
  };

  if (!takebackId) {
    return <div>Error: No trade-in found. Please try again.</div>;
  }

  return (
    <div className="flex flex-col items-center justify-between h-[calc(100vh-81px)] p-6">
      <div className="flex flex-col h-full items-center justify-center">
        <div className="bg-white flex flex-col my-auto items-center text-center px-large">
          <QRCode value={takebackId} size={200} />
          <h2 className="text-primary text-6xl mt-x-large">
            Registration complete
          </h2>
          <span className="text-tertiary text-base mt-regular">
            Present this QR code to the in-store associate to continue.
          </span>
        </div>
        <Button
          onClick={handleSignOut}
          variant="secondary"
          type="button"
          className="w-full bottom-0"
        >
          Sign Out
        </Button>
      </div>
    </div>
  );
}
